import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'pl',
  months: [
    'stycznia',
    'lutego',
    'marca',
    'kwietnia',
    'maja',
    'czerwca',
    'lipca',
    'sierpnia',
    'września',
    'października',
    'listopada',
    'grudnia',
  ],
  monthsShort: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  weekdays: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
  weekdaysMin: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
  weekdaysShort: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'piąt.', 'sob.'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd D MMMM HH:mm',
    l: 'D.M.YYYY',
    'l-Y': 'D.M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s rok temu', few: '%s lata temu', many: '%s lat temu', other: '%s roku temu' },
    M: { one: '%s mies. temu', few: '%s mies. temu', many: '%s mies. temu', other: '%s mies. temu' },
    w: { one: '%s tydz. temu', few: '%s tyg. temu', many: '%s tyg. temu', other: '%s tyg. temu' },
    d: { one: '%s dzień temu', few: '%s dni temu', many: '%s dni temu', other: '%s dni temu' },
    h: { one: '%s godz. temu', few: '%s godz. temu', many: '%s godz. temu', other: '%s godz. temu' },
    m: { one: '%s min temu', few: '%s min temu', many: '%s min temu', other: '%s min temu' },
    s: { one: '%s sek. temu', few: '%s sek. temu', many: '%s sek. temu', other: '%s sek. temu' },
  },
  future: {
    y: { one: 'za %s rok', few: 'za %s lata', many: 'za %s lat', other: 'za %s roku' },
    M: { one: 'za %s mies.', few: 'za %s mies.', many: 'za %s mies.', other: 'za %s mies.' },
    w: { one: 'za %s tydz.', few: 'za %s tyg.', many: 'za %s tyg.', other: 'za %s tyg.' },
    d: { one: 'za %s dzień', few: 'za %s dni', many: 'za %s dni', other: 'za %s dni' },
    h: { one: 'za %s godz.', few: 'za %s godz.', many: 'za %s godz.', other: 'za %s godz.' },
    m: { one: 'za %s min', few: 'za %s min', many: 'za %s min', other: 'za %s min' },
    s: { one: 'za %s sek.', few: 'za %s sek.', many: 'za %s sek.', other: 'za %s sek.' },
  },
  pastLong: {
    y: { one: '%s rok temu', few: '%s lata temu', many: '%s lat temu', other: '%s roku temu' },
    M: { one: '%s miesiąc temu', few: '%s miesiące temu', many: '%s miesięcy temu', other: '%s miesiąca temu' },
    w: { one: '%s tydzień temu', few: '%s tygodnie temu', many: '%s tygodni temu', other: '%s tygodnia temu' },
    d: { one: '%s dzień temu', few: '%s dni temu', many: '%s dni temu', other: '%s dni temu' },
    h: { one: '%s godzinę temu', few: '%s godziny temu', many: '%s godzin temu', other: '%s godziny temu' },
    m: { one: '%s minutę temu', few: '%s minuty temu', many: '%s minut temu', other: '%s minuty temu' },
    s: { one: '%s sekundę temu', few: '%s sekundy temu', many: '%s sekund temu', other: '%s sekundy temu' },
  },
  futureLong: {
    y: { one: 'za %s rok', few: 'za %s lata', many: 'za %s lat', other: 'za %s roku' },
    M: { one: 'za %s miesiąc', few: 'za %s miesiące', many: 'za %s miesięcy', other: 'za %s miesiąca' },
    w: { one: 'za %s tydzień', few: 'za %s tygodnie', many: 'za %s tygodni', other: 'za %s tygodnia' },
    d: { one: 'za %s dzień', few: 'za %s dni', many: 'za %s dni', other: 'za %s dni' },
    h: { one: 'za %s godzinę', few: 'za %s godziny', many: 'za %s godzin', other: 'za %s godziny' },
    m: { one: 'za %s minutę', few: 'za %s minuty', many: 'za %s minut', other: 'za %s minuty' },
    s: { one: 'za %s sekundę', few: 'za %s sekundy', many: 'za %s sekund', other: 'za %s sekundy' },
  },
  abbr: {
    y: { one: '%s rok', few: '%s lata', many: '%s lat', other: '%s roku' },
    M: { one: '%s mies.', few: '%s mies.', many: '%s mies.', other: '%s mies.' },
    w: { one: '%s tydz.', few: '%s tyg.', many: '%s tyg.', other: '%s tyg.' },
    d: { one: '%s dn.', few: '%s dn.', many: '%s dn.', other: '%s dn.' },
    h: { one: '%s godz.', few: '%s godz.', many: '%s godz.', other: '%s godz.' },
    m: { one: '%s min', few: '%s min', many: '%s min', other: '%s min' },
    s: { one: '%s sek.', few: '%s sek.', many: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s rok', few: '%s lata', many: '%s lat', other: '%s roku' },
    M: { one: '%s miesiąc', few: '%s miesiące', many: '%s miesięcy', other: '%s miesiąca' },
    w: { one: '%s tydzień', few: '%s tygodnie', many: '%s tygodni', other: '%s tygodnia' },
    d: { one: '%s dzień', few: '%s dni', many: '%s dni', other: '%s dni' },
    h: { one: '%s godzina', few: '%s godziny', many: '%s godzin', other: '%s godziny' },
    m: { one: '%s minuta', few: '%s minuty', many: '%s minut', other: '%s minuty' },
    s: { one: '%s sekunda', few: '%s sekundy', many: '%s sekund', other: '%s sekundy' },
  },
  justNow: 'Przed chwilą',
  yesterday: 'Wczoraj',
  today: 'Dziś',
  tomorrow: 'Jutro',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY', end: 'D MMMM YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    'Y-1': { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm' },
    mt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    dt: { start: 'D MMM HH:mm', end: 'D MMM HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY HH:mm', end: 'D MMM YYYY HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM HH:mm', end: 'D MMM HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'pl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
